module.exports = __webpack_public_path__ + "img/clock.7a472849.svg";